import { Electricite } from '@model/electricite';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { map, catchError } from "rxjs/operators";
import { HttpClient } from '@angular/common/http';
import { ApiService, ApiUrlService } from '@theme/utils/api.service';
import { NoInternetHelper } from '@theme/utils/no-internet-helper';
@Injectable({
  providedIn: 'root'
})
export class ElectriciteService {
  electricite: Electricite;
  public edit: boolean = false;
  public type: string = "";
  private urlBase = environment.publicUrl;
  private namespace = "agency/electricite";
  private url ='private/agency/electricite';

  constructor(private api: ApiService, private apiUrl: ApiUrlService, private http: HttpClient) {}

  setElectricite(electricite: Electricite) {
    this.electricite = electricite
  }
  getElectricite(): Electricite {
    return this.electricite
  }
  add(data: Electricite): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    if (data.uuid) {
      return this.update(data);
    } else {
      return this.create(data);
    }
  }
  create(data: Electricite): Observable<any> {
    return this.api._post(`${this.url}/new`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  update(data: Electricite): Observable<any> {
    return this.api._post(`${this.url}/${data.uuid}/edit`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getList(tenant?: string, contract?: string, all: string = null): Observable<Electricite[]> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._get(`${this.url}/`, {
      tenant: tenant,
      all:all,
      contract: contract
    }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getSingle(uuid: string, mois: string, contract: string): Observable<Electricite> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._get(`${this.url}/show`, {
      contract: contract,
      mois: mois,
      uuid: uuid
    }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getPrinter(type: string, agencyKey: string, userKey: string, data: any): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return;
    }

    let url = 'printer/' + this.namespace + '/' + agencyKey + '/' + userKey;
    if(type === 'LISTE') {
      if(data && data !== undefined) {
        for (const k in data) {
          if (data.hasOwnProperty(k)) {
            if(k !== 'uuid') {
              url += '/' + (data[k] !== undefined && data[k] !== '' ? data[k] : null);
            }
          }
        }
      } else {
        url += '/LOYER/null/null/null/null/null/null/null/null/null/DESC/null/null/null/null/10/null'
      }
    }
    if(type === 'SHOW') {
      url = (data) ? url +'/' + data : url;
    }
    window.open(`${this.urlBase}/${url}`, '_blank');
  }
  getPrinterAssocie(data: any): Observable<any> {
    return this.apiUrl._post(`printer/agency/electricite/associe`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getExport(agencyKey: string, userKey: string, data: any): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return;
    }

    let url = 'export/electricite/' + agencyKey + '/' + userKey;
    if(data && data !== undefined) {
      for (const k in data) {
        if (data.hasOwnProperty(k)) {
          if(k !== 'uuid') {
            url += '/' + data[k];
          }
        }
      }
    } else {
      url += '/LOYER/null/null/null/null/null/null/null/null/null/DESC/null/null/null/null/10/null'
    }
    window.open(`${this.urlBase}/${url}`);
  }
  getGenerer(){
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }
    var url = this.urlBase + '/import/agency/model/electricite'
    window.open(`${url}`);
  }
  import(data){
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }
    var url = 'private/import/agency'
    return this.api._post(`${url}/electricite`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  /**
   * Preview de l'import - simule l'impact sans enregistrer
   */
  previewImport(data: any): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }
    return this.api._post(`${this.url}/preview`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  /**
   * Valider et enregistrer l'import après preview
   */
  validatePreview(data: any): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }
    return this.api._post(`${this.url}/validate-preview`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  /**
   * Récupère la liste simple des immeubles de l'agence pour le wizard.
   */
  getHousesForWizard(): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._get(`${this.url}/houses`, {}).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  /**
   * Récupère les contrats actifs des immeubles sélectionnés + dernier index connu.
   */
  getContractsByHouses(houseIds: number[], periode: string): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    const params = { houses: houseIds.join(','), periode: periode };
    return this.api._get(`${this.url}/contracts-by-houses`, params).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  /**
   * Télécharge un template Excel pré-rempli pour les immeubles + période choisis.
   * Utilise HttpClient pour bénéficier du JWT interceptor automatiquement.
   */
  downloadTargetedTemplate(houseIds: number[], periode: string): Observable<Blob> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    const body = { houses: houseIds, periode: periode };
    return this.http.post(`${this.urlBase}/api/${this.url}/template-excel`, body, {
      responseType: 'blob'
    }).pipe(
      map((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `TEMPLATE_CONSO_ELECTRICITE_${periode}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        return blob;
      }),
      catchError((error: any) => throwError(error))
    );
  }

  /**
   * Upload d'un fichier Excel rempli → renvoie les options parsées (format compatible preview).
   */
  importExcelFile(file: File, periode: string): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('periode', periode);
    return this.api._post(`${this.url}/import-excel`, formData).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getDelete(uuid: string): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._delete(`${this.url}/${uuid}/delete`).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
}
